<template>
  <div class="c-header" :class="className" :style="{'background-color': backgroundColor}">
    <div class="left">
      <slot name="left">
        <div class="tools-left">
          <div class="icon-box" v-if="!noValue(currentLeftIcon1) || type === 'white'" style="margin-right: 10px" @click="currentLeftFn1">
            <div
              class="icon"
              :class="{'active': isBookPage}"
              :style="{backgroundImage: `url(${require('@/assets/image/header/' + currentLeftIcon1)})`}"
            ></div>
          </div>
          <div class="icon-box" v-if="!noValue(leftIcon2)" @click="leftFn2">
            <div class="icon" :style="{backgroundImage: `url(${'@/assets/image/header/' + leftIcon2})`}"></div>
          </div>
        </div>
      </slot>
    </div>
    <div class="middle" :class="{white: type === 'white'}" :type="language">
      <slot name="middle"><p>{{title}}</p></slot>
    </div>
    <div class="right">
      <slot name="right">
        <div class="tools-right">
          <div class="icon" v-if="!noValue(rightIcon2)" :style="{backgroundImage: `url(${require('@/assets/image/header/' + rightIcon2)})`}" @click="rightFn2" style="margin-right: 10px"></div>
          <div class="icon" v-if="!noValue(rightIcon1)" :style="{backgroundImage: `url(${require('@/assets/image/header/' + rightIcon1)})`}" @click="rightFn1"></div>
        </div>
      </slot>
    </div>
    <slot></slot>
  </div>
</template>
<script type="text/ecmascript-6">
/*
 *  header提供了两种使用方式：
 *  1: 通过默认的结构，传入props，修改两侧的图标、图标绑定的方法，以及中间的标题；base-component推荐使用1；
 *  2：不符合默认结构的header，可以直接通过slot插槽（left、middle、right）,覆盖原有的结构；base-component推荐使用2；
*/
export default {
  props: {
    /** 左边第一个图标 */
    leftIcon1: {
      type: String,
      default: ''
    },
    /** 左边第二个图标 */
    leftIcon2: {
      type: String,
      default: ''
    },
    /** 右边第一个图标（靠右） */
    rightIcon1: {
      type: String,
      default: ''
    },
    /** 右边第二个图标（靠左） */
    rightIcon2: {
      type: String,
      default: ''
    },
    /** 左边第一个图标绑定的方法 */
    leftFn1: {
      type: Function,
      default: function() {}
    },
    /** 左边第二个图标绑定的方法 */
    leftFn2: {
      type: Function,
      default: function() {}
    },
    /** 右边第一个图标（靠右）绑定的方法 */
    rightFn1: {
      type: Function,
      default: function() {}
    },
    /** 右边第二个图标（靠左）绑定的方法 */
    rightFn2: {
      type: Function,
      default: function() {}
    },
    /** 标题 */
    title: {
      type: String,
      default: ''
    },
    /** navgation bar 背景色 */
    backgroundColor: {
      type: String,
      default: '#FFFFFF'
    },
    isBackNav: {
      type: Boolean,
      default: false
    },
    fixedBackPath: {
      type: String,
      default: ''
    },
    isBookPage: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentLeftIcon1: this.leftIcon1,
      currentLeftFn1: this.leftFn1
    }
  },
  created() {
    this._initNav()
  },
  mounted() {
    console.log(this.currentLeftIcon1)
  },
  activated() {
    this._initNav()
  },
  methods: {
    _initNav() {
      let previousPath = window.sessionStorage.previousPath
      if (this.isBackNav) {
        if (this.noValue(this.fixedBackPath)) {
          if (previousPath === '/') {
            this.currentLeftIcon1 = this.backgroundColor === 'none' ? 'home.png' : 'home_2.png'
            this.currentLeftFn1 = () => {
              this.$router.replace('/home')
            }
          } else {
            this.currentLeftIcon1 = this.leftIcon1 || (this.backgroundColor === 'none' ? 'return_round.png' : 'return.png')
            this.currentLeftFn1 = () => {
              this.$router.go(-1)
            }
          }
        } else {
          this.currentLeftIcon1 = this.leftIcon1 || (this.backgroundColor === 'none' ? 'return_round.png' : 'return.png')
          this.currentLeftFn1 = () => {
            this.backToFixedPath()
          }
        }
        if (this.isBookPage) {
          this.currentLeftIcon1 = this.leftIcon1 ? this.leftIcon1 : 'returnBook.png'
        }
      }
    },
    backToFixedPath() {
      this.$router.replace(this.fixedBackPath)
      // let previousPathList = !this.noValue(window.sessionStorage.getItem('previousPathList')) ? JSON.parse(window.sessionStorage.getItem('previousPathList')) : []
      // if (previousPathList.length > 1 && previousPathList[previousPathList.length - 2] === this.fixedBackPath) {
      //   this.$router.go(-1)
      // } else {
      //   this.$router.replace(this.fixedBackPath)
      // }
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.c-header
  @extend .flex-row
  @extend .flex-between
  width 100%
  height 45px
  overflow hidden
  &.c-header-login, &.c-header-12
    >.left
      padding-left 24px
      >.tools-left
        >.icon-box
          >.icon
            background-size 24px 24px
  &.c-header-12
    height 48px
    >.left
      padding-left 12px
    >.middle
      >p
        @extend .hs-font-subtitle-big
        color $color_black_900
  &.c-header-new
    height 48px
    >.middle
      >p
        @extend .hs-font-subtitle-big
        color $color_black_900
  .left,
  .right
    @extend .flex-row
    width 80px
    height 100%
    .tools-left,
    .tools-right
      @extend .flex-row
      width 100%
      height 100%
      .icon-box
        @extend .flex-start
        padding-right 20px
        height 45px
      .icon
        width 30px
        height 30px
        background-size 25px 25px
        background-repeat no-repeat
        background-position 0 center
        &.active
          width 9px
          height 16px
          margin-left 5px
          background-size 100% 100%
  .left
    @extend .flex-start
    padding-left 15px
    .tools-left
      @extend .flex-start
  .right
    @extend .flex-end
    padding-right 15px
    .tools-right
      @extend .flex-end
  .middle
    @extend .flex-center
    width calc(100% - 160px)
    height 100%
    font-size 16px
    word-break break-all
    color $color_black_900
    &.white
      color $color_white
      p
        font-weight 500
    p
      line-height 22px
      // font-weight bold
      // max-height 44px
      // ellipsis(2)
      text-align center
    h2
      text-align center
  // .middle[type="EN"]
  //   p
  //     font-size 1rem
  //     line-height 1.2em
</style>
